import type { AIMarketplaceRow } from '../../repositoryblueprint/framework';

type Props = { items?: AIMarketplaceRow[] };

export function AIMarketplaceStructurePanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.area} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.area}</p>
            <span className="shrink-0 rounded-full bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
              {item.status}
            </span>
          </div>
          <p className="mt-1 font-mono text-xs text-slate-500">{item.path}</p>
          <p className="text-xs text-slate-400">{item.modules} modules</p>
        </div>
      ))}
    </div>
  );
}
